import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=54588726&scoped=true"
import script from "./Marketing.vue?vue&type=script&lang=js"
export * from "./Marketing.vue?vue&type=script&lang=js"
import style0 from "./Marketing.vue?vue&type=style&index=0&id=54588726&prod&scoped=true&lang=css"
import style1 from "./Marketing.vue?vue&type=style&index=1&id=54588726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54588726",
  null
  
)

export default component.exports